<template>
    <div class="partners-card">
      <img src="/images/promo/connect-features/partners-card.svg" alt="Partners card" />
    </div>
</template>

<script>
export default {};
</script>
